import _ from "lodash"
import axios from "axios"
import html2canvas from "html2canvas"

window._ = _
window.html2canvas = html2canvas

if (import.meta.env.DEV) {
  // add a global interceptor
  axios.interceptors.request.use(config => {
    const match = document.cookie.match(/XDEBUG_SESSION=([^;]+)/)
    if (match) {
      const separator = config.url.includes("?") ? "&" : "?"
      config.url += `${separator}XDEBUG_SESSION_START=${match[1]}`
    }
    return config
  })
}

window.axios = axios

axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest"

let token = document.head.querySelector('meta[name="csrf-token"]')

if (token) {
  axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content
} else {
  // eslint-disable-next-line
  console.error("CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token")
}
